import { render } from "./AdminAllObjects.vue?vue&type=template&id=acbf792a&scoped=true"
import script from "./AdminAllObjects.vue?vue&type=script&lang=js"
export * from "./AdminAllObjects.vue?vue&type=script&lang=js"

import "./AdminAllObjects.vue?vue&type=style&index=0&id=acbf792a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acbf792a"]])

export default __exports__